import React, { useState, lazy, Suspense, CSSProperties } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useAuth } from "../hooks/useAuth";
import { useLocation, useNavigate } from "react-router-dom";
import { Pages } from "../shared/constants";
import PopupDialog from "./PopupDialog";

// Lazy-loaded modules
const SurchargeProcessingLanding = lazy(() => import("../modules/surcharge-processing/pages/SurchargeProcessingLanding"));
const ReportingLanding = lazy(() => import("../modules/reporting/pages/ReportingLanding"));
const FormulaSimulatorLanding = lazy(() => import("../modules/formula-simulator/pages"));

const Overview = () => {
  const { isAuthenticated, userRoles } = useAuth();
  const tabs = [
    { key: "SurchargeProcessingLanding", label: "Surcharge Processing" },
    { key: "ReportingLanding", label: "Reporting" },
    { key: "FormulaSimulatorLanding", label: "Formula Simulator" },
  ];
  const navigate = useNavigate();
  const location = useLocation(); // Tracks current route dynamically

  const [activeTab, setActiveTab] = useState<string>("SurchargeProcessingLanding");

  const [activeTabName, setActiveTabName] = useState<string>("Surcharge Processing");

  // Automatically update activeTab when route changes
  React.useEffect(() => {
    // console.log("Route changed to:", location.pathname);

    if (location.pathname === Pages.SurchargeProcessing) {
      setActiveTab("SurchargeProcessingLanding");
      handleTabClick("SurchargeProcessingLanding");
    } else if (location.pathname.startsWith(Pages.Reporting)) {
      setActiveTab("ReportingLanding");
    } else if (location.pathname.startsWith(Pages.FormulaSimulator)) {
      setActiveTab("FormulaSimulatorLanding");
    }
  }, [location.pathname]); // Runs only when the route changes

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
    // console.log("Clicked Tab:", tab);

    if (tab === "SurchargeProcessingLanding") {
      setActiveTabName("Surcharge Processing");
      navigate(Pages.SurchargeProcessing); // Correct path
    } else if (tab === "ReportingLanding") {
      setActiveTabName("Reporting");
      navigate(Pages.Reporting); // Correct path
    } else if (tab === "FormulaSimulatorLanding") {
      setActiveTabName("Formula Simulator");
      navigate(Pages.FormulaSimulator); // Correct path
    }
  };

  return (
    <div style={containerStyles}>
      {isAuthenticated ? (
        <div>
          {/* <p>🔑 Your Roles: {userRoles.join(", ") || "No Roles Assigned"}</p> */}

          {/* Navigation Tabs */}

          <div className="nav nav-tabs">
            {tabs.map((tab) => (
              <li className="nav-item" key={tab.key}>
                <button className={`nav-link ${activeTab === tab.key ? "active fw-bold" : ""}`} style={colorStyle} onClick={() => handleTabClick(tab.key)}>
                  {tab.label}
                </button>
              </li>
            ))}
          </div>

          {/* Render Selected Module */}
          <div className="tab-content border ap-mt-3">
            <Suspense fallback={<div>Loading...</div>}>
              {activeTab === "SurchargeProcessingLanding" && <SurchargeProcessingLanding />}
              {activeTab === "ReportingLanding" && <ReportingLanding />}
              {activeTab === "FormulaSimulatorLanding" && <FormulaSimulatorLanding />}
            </Suspense>
          </div>
          <PopupDialog />
        </div>
      ) : (
        <p>Authenticating...</p>
      )}
    </div>
  );
};

export default Overview;

/* Styles */
const containerStyles: CSSProperties = {
  padding: "7px 1px 40px",
  minHeight: "calc(100vh - 120px)",
  overflowY: "auto" as "auto",
};

const colorStyle: CSSProperties = {
  color: "rgb(0, 154, 73)",
};
